const state = {
  data: {
    infoDialog: false,
    title: '',
    content: '',
    closeBtnLabel: 'Aceptar.'
  }
}

const getters = {
  getData: state => state.data,
  isDialogActived: state => state.data.infoDialog
}

const actions = {
  setData (context, data) {
    context.commit('setData', data)
  },
  setDialogActivedFalse (context) {
    let data = {
      infoDialog: false,
      title: '',
      content: '',
      closeBtnLabel: 'Aceptar.'
    }
    context.commit('setData', data)
  }
}

const mutations = {
  setData (state, data) {
    state.data = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
